import axios from 'axios';

const list = (data) => axios.get('/custom/partners/list', data);
const save = (data) => axios.post('/custom/partners/saveOrUpdate', data);
const del = (data) => axios.post('/custom/partners/delete', data); //delete

export default {
  list,
  save,
  del,
}